import React, { useState, useEffect, useRef  } from 'react';
import axios from "../../../../axios";
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Tooltip from '@material-ui/core/Tooltip';
import Divider from '@material-ui/core/Divider';
import { useTranslation } from 'react-i18next';
import { debounce } from "lodash-es";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { isMobile, isTablet } from "react-device-detect";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import { sendRequestToUpdateValue } from '../../RequestLogic';
import { useCallback } from 'react';
import { functions, recursiveJsonReader1, renderExecuteServerEventAPIData } from '../../ApplicationAPI/applicationApi';
import { GetState, GetStateFromData } from '../../../CustomHooks/CustomHooks';
import CustomizedAlert from '../../../../ReusableComponents/Alert/CustomizedAlert';
import { useDispatch } from 'react-redux';
import { getDevice, updateValue } from '../../IFormDesignerLogic';
import { setMap, updateGridContexts } from '../../../../Redux/Actions/FormStateActions';
import { MenuItem, Select } from '@material-ui/core';
import { getHooksId } from '../../../../Resources/globalFunctions';

function isMobileDevice() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  const width = window.innerWidth;
  // Check for mobile user agents
  const isMobile = /android|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);
  // Additional check for screen size
  const isMobileScreen = width <= 768; // A typical max width for mobile devices
  // Check if touch events are supported
  const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  
  return isMobile && isMobileScreen && isTouchDevice;
}

function isTabletDevice() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  const width = window.innerWidth;
  // Check for tablet user agents
  const isTablet = /ipad|android(?!.*mobile)|tablet/i.test(userAgent);
  // Additional check for screen size
  const isTabletScreen = width > 768 && width <= 1280; // Tablet screen range
  // Check if touch events are supported
  const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  
  return isTablet && isTabletScreen && isTouchDevice;
}

const useStyles = makeStyles({
  '@global': {
    '*::-webkit-input-placeholder': { 
      color: "#606060",
    }
  },
  button: {
    position: 'relative',
  },
  data: {
    fontSize: "15px",
    fontWeight: "bold",
  },
  dialog: {
    position:"absolute",
    height: (styleData) => styleData?.isMobileDisplay ? "600px" : "440px",
    width: (styleData) => styleData?.isMobileDisplay ? styleData?.tempCanWidth ? `${parseInt(styleData?.tempCanWidth) * 0.9 }px` : "600px" : "790px",
    maxWidth:"100%",
    overflow: "hidden",
    direction: window?.psh_configs?.selectedLanguage==="ar" || window?.psh_configs?.selectedLanguage==="ar-SA" ?  "rtl" : "ltr",
  },
  dialogTitle: {
    padding: 16,
    width:"100%",
    boxSizing: "border-box"
  },
  dialogContent: {
    padding: 0,
    width:"100%",
    overflow:"hidden",
    "& .MuiDialogContentText-root" : {
      height: "100%"
    }
  },
  dialogActions: {
    height: 50,
    width:"100%",
    background: "#F5F5F5 0% 0% no-repeat padding-box",
    opacity: 1,
    padding: "11px 16px 11px",
    boxSizing: "border-box"
  },
  btn1: {
    width: "54px",
    height: "28px",
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    border: "1px solid #C4C4C4",
    borderRadius: "2px",
    opacity: 1,
    padding: "5px 8px 6px 8px",
    marginRight: "5px",
    marginLeft: "5px",
  },
  btn2: {
    "margin-right": style => style?.translationStyle1 ? "unset" : "0px !important",
    "margin-left": style => style?.translationStyle1 ? "0px !important" : "unset",
    width: "50px",
    height: "28px",
    background: "#0072C6 0% 0% no-repeat padding-box",
    borderRadius: "2px",
    opacity: 1,
    padding: "5px 8px 6px 8px"
  },
  btnlabel: {
    textTransform: "none",
    font: "normal normal 600 12px/17px Open Sans"
  },

  closeIcon:{
    fontSize: 10,
  },
  tableContainer: {
    overflow:"auto",
    display: "flex", 
    flexDirection: "column",
    marginRight: "2.02%",
    marginLeft: "3.16%",
    maxHeight: (style) => style?.isMobileDisplay ? "calc(100% - 108px)" : "252px", 
    width: (style) => style?.isMobileDisplay ? "calc(100% - 18px)" : "94.8%",
    margin: (style) => style?.isMobileDisplay ? "0px 8px" : "",
    padding: "none",
    border: "1px solid #C4C4C4"
  },
  table: {
    minWidth: 300,
    flex: "auto",
  },
  tableHead: {
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    opacity: 1,
    textAlign: "left",
    font: "normal normal 600 14px/19px OpenSans",
    letterSpacing: "0px",
    color: "#606060",
    height: "36px", 
  },
  tableBody: {
    textAlign: "left",
    font: "normal normal 600 14px/19px OpenSans",
    letterSpacing: "0px",
    color: "#000000",
  },
  tableHeadRow: {
    height: "36px",
  },
  tableBodyRow: {
    height: "36px",
  },
  tableHeadCell: {
    font: "normal normal 600 14px/19px  Open Sans",
    height: "auto",
    color: "#606060",
    textAlign:  window?.psh_configs?.selectedLanguage==="ar" || window?.psh_configs?.selectedLanguage==="ar-SA" ? "right" : "left" ,
  },
  tableBodyCell: {
    font: "normal normal 600 14px/19px Open Sans",
    height: "auto",
    textAlign:  window?.psh_configs?.selectedLanguage==="ar" || window?.psh_configs?.selectedLanguage==="ar-SA" ? "right" : "left" ,
    color: "#000000",
  },
  tableCheckCell: {
    padding: "10px 8px 0px 8px",
    width: "30px",
    borderRight: "1px solid #C4C4C4",
  },
  tableCheckCellSafari: {
    padding: "0px 8px 20px 8px",
    width: "30px",
    borderRight: "1px solid #C4C4C4",
  },
  tableInput: {
    border: "1px solid #C4C4C4",
    borderRadius: "2px", 
    opacity: 1
  },
  dialogHead: { 
    flex: 1, 
    display: 'flex'
  },
  dialogHead1: {
    textAlign: "left",
    fontSize:"17px",
    font:"normal normal 600 14px/19px Open Sans", 
    width: "100%",
    whiteSpace: "nowrap",
    wordWrap: "break-word",
    overflow: "hidden",
    textOverflow: "ellipsis",
    marginRight: "8px",
    lineHeight: "1.5",
    fontWeight:"bold",
    display: window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA"? "flex":""

  },
  dialogHead11: {
    textAlign: "left",
    fontSize:"17px",
    font:"normal normal 600 14px/19px Open Sans", 
    width: "100%",
    display: "-webkit-box",
    "-webkit-box-orient": "vertical",
    "-webkit-line-clamp": "2",
    whiteSpace: "normal",
    wordWrap: "break-word",
    overflow: "hidden",
    textOverflow: "ellipsis",
    marginRight: "8px",
    lineHeight: "1.5",
    fontWeight:"bold",
    display: window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA"? "flex":""
  },
  dialogHead2: {
    flex: 1,
    display: 'flex', 
    justifyContent: 'flex-end',
    marginLeft: window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA"? "12px !important":""
  },

  pagingButtonGroup: {
    display: 'flex', 
    justifyContent: 'flex-end'
  },
  dialogHeadIcon: {
    height:"15px",
    width:"15px"
  },
  divider: {
    backgroundColor:"#E4E4E4"
  },
  dialogContentHead: {
    margin:"2px", 
    flex: 1, 
    display: 'flex',
    flexDirection: (styleData) => styleData?.isMobileDisplay ? "column" : "",
  },
  allColumns: {
    "border-top-left-radius": "2px",
    "border-bottom-left-radius": "2px",
    "border-top-right-radius": "2px !important",
    "border-bottom-right-radius": "2px !important",
    textAlign: "left",
    font: "normal normal normal 12px/17px Open Sans",
    letterSpacing: "0px",
    color: "#606060",
    opacity: 1,
    fontSize:"12px",
    fontColor:"#C4C4C4",
    border:"1px solid #C4C4C4",
    height:"32px !important",
    width: style => style?.isMobileDisplay ? "" : "180px",
    marginLeft: window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA"? "12px !important":"",
    flex: style => style?.isMobileDisplay ? 1 : "",
    margin:"8px 8px 8px 0px",
    "& .MuiSelect-select" : {
      paddingLeft: "8px",
    },
    "& .MuiSelect-select:focus" : {
      backgroundColor: "unset"
    },
    "&.MuiInputBase-root fieldset" : {
      display: "none"
    },
    "& .MuiSelect-icon" : {
      top: "calc(50% - 8px)"
    },
  },
  menuRoot : {
    maxHeight: style => style?.isMobileDisplay ? "480px" : "350px"
  },
  searchBox: {
    textAlign: "left",
    font: "normal normal normal 12px/17px Open Sans",
    letterSpacing: "0px",
    color: "#606060",
    opacity: 1,
    fontSize:"12px",
    fontColor:"#C4C4C4",
    border:"1px solid #C4C4C4",
    height:"30px",
    width: style => style?.isMobileDisplay ? "" : "200px",
    flex: style => style?.isMobileDisplay ? 1 : "",
    margin:"8px 0px 8px 0px"
  },
  searchInput: {
    fontSize:"12px",
    fontColor:"#C4C4C4",
    padding:"6px 0px 2px 8px",
    border:"none !important",
    outline:"none !important",
    boxShadow: "unset !important",
    "-webkit-box-shadow" : "unset !important",
    width: style => style?.isMobileDisplay ? "calc(100% - 20px)" : "176px",
  },
  searchIcon: {
    paddingBottom:"5px",
  },
  rightArrowIcon: {
    lineHeight: "10px !important",
    padding:"0px",
    border:"1px solid #C4C4C4",
    margin:"8px 12px 8px 3px !important",
    height:"28px", 
    backgroundColor:"white"
  },
  leftArrowIcon: {
    lineHeight: "10px !important",
    padding:"0px",
    border:"1px solid #C4C4C4",
    margin:"8px 3px 8px 20px !important",
    height:"28px", 
    backgroundColor:"white"
  },
  leftArrowIcon1: {
    lineHeight: "10px !important",
    padding:"0px",
    border:"1px solid #C4C4C4",
    margin:"8px 3px 8px 12px !important",
    height:"28px", 
    backgroundColor:"white"
  },
  rightArrowIcon1: {
    lineHeight: "10px !important",
    padding:"0px",
    border:"1px solid #C4C4C4",
    margin:"8px 16px 8px 3px !important",
    height:"28px", 
    backgroundColor:"white"
  },

});

export default function PickListPopup(props) {
  const isTabletOrMobile = isMobileDevice() || isTabletDevice();
  const translationStyle1 =  window?.psh_configs?.selectedLanguage==="ar" || window?.psh_configs?.selectedLanguage==="ar-SA"
  const deviceM = getDevice();
  const isMobileDisplay = deviceM === "mobile";
  const {tempCanHeight, tempCanWidth} = GetState("tempCanHeight","tempCanWidth");
  const classes = useStyles({isMobile, translationStyle1, isMobileDisplay, tempCanWidth});
  const style = props.style;

  const {open, onClose} = props;
  const dispatch = useDispatch()
  const [pages, setPages] = useState(0);
  const [pageNo, setPageNo] =  useState(1);
  const [isLastPage, setIsLastPage] =  useState(false);
  const [search, setSearch] = useState("");
  const colId = useRef(-1);
  const [empty, setEmpty] = useState(false);
  const [check, setCheck] = useState(false);
  const [rowSelect, setRowSelect] = useState(-1);
  const [selectedName, setSelectedName] = useState();
  const [selectedData, setSelectedData] = useState();
  const [selected, setSelected] = useState([]);
  const [result, setResult] = useState("");
  const[previousPage,setPreviousPage]=useState(false);
  const [colIdState, setColIdState] = useState(-1);
  
  const [column, setColumn] = useState([]);
  const [columnDropdown, setColumnDropdown] = useState([]);
  const [data, setData] = useState([]);
  const[selectedIndex,setSelectedIndex]=useState(-1);

  const [defaultColumnValue, setDefaultColumnValue] = useState("");

  const { t } = useTranslation();
  const inputRef = useRef(null);
  const touchedBrowsePagesRef = useRef({});
  const touchedSearchPagesRef = useRef({});
  const browsePageNamesRef = useRef({});
  const searchPageNamesRef = useRef({});

  const [columnWidthMap,setColumnWidthMap] = useState(new Map());
  const [enableColumnMap,setEnableColumnMap] = useState(new Map());
  const [alertData, setAlertData] = useState({'open':false, 'showConfirm':'showNotification'});

  const [ hiddenColumnIndexList, setHiddenColumnIndexList ] = useState([]);

  // Search mode state: tracks selections made while search is active separately
  // from original paginated-browse selections (which are keyed by pageNo).
  // Without this, PicklistSelectedAll[pageNo] for original pages bleeds into
  // search-result pages that share the same pageNo key.
  const [isSearchMode, setIsSearchMode] = useState(false);
  const [searchSelectedAll, setSearchSelectedAll] = useState({});
  const [searchSelectedAllNames, setSearchSelectedAllNames] = useState({});
  const [searchSelectedAllData, setSearchSelectedAllData] = useState({});
  const [searchMultiSelectDynamic, setSearchMultiSelectDynamic] = useState({});

  const contexts = GetStateFromData(props.containerId);
  const gridContexts = GetStateFromData(props.containerId,"data2");

  const {
    currentAdvanceListviewStateJson,
    openCanvasForPreview,
    subFormListviewJson,
  } = gridContexts.gridStates;

  const {updateJson, changeSectionLayout, formMataData, microFrontendData, builderMode, formState2, deleteControl,customControlIdList,setCustomControlIdList,listviewColumnInfo }=contexts.contexts;
  const { updatedComponentInFormState, removeAndUpdateComponentInFormState} =updateJson

  
  function agentHas(keyword) {
    return window.navigator.userAgent.toLowerCase().search(keyword.toLowerCase()) > -1;
    }

 let isSafariBrowser = function isSafari() {
  return (!!window.ApplePaySetupFeature || !!window.safari) && agentHas("Safari") && !agentHas("Chrome") && !agentHas("CriOS");
  }
  
  
  if(props.data.style.BatchSize==="" ||props.data.style.BatchSize === undefined){
    props.data.style.BatchSize = 10;
  }
  if(props.data.style.PicklistSelectedAllNames==="" ||props.data.style.PicklistSelectedAllNames === undefined){
    props.data.style.PicklistSelectedAllNames = {};
  }
  if(props.data.style.PicklistSelectedAllData==="" ||props.data.style.PicklistSelectedAllData === undefined){
    props.data.style.PicklistSelectedAllData = {};
  }
  if(props?.data?.style?.PicklistSelectedAll === "" || props?.data?.style?.PicklistSelectedAll === undefined){
    props.data.style.PicklistSelectedAll = {};
  }

  const hasStoredSelectionForPage = (selectionStore, currentPage) => Object.prototype.hasOwnProperty.call(selectionStore || {}, currentPage);

  const getPersistedPicklistValues = () => {
    const rawValueList = [
      props?.data?.style?.Picklists,
      props?.data?.style?.Picklist,
      props?.data?.value
    ];

    return Array.from(new Set(rawValueList.flatMap((value) => {
      if(typeof value !== "string"){
        return [];
      }

      return value.split(",").map((item) => item?.trim()).filter(Boolean);
    })));
  };

  const getPersistedSingleValue = () => {
    const value = props?.data?.style?.Picklist || props?.data?.value || props?.data?.Picklist;
    return typeof value === "string" ? value.trim() : "";
  };

  const normalizePicklistValue = (value) => String(value ?? "").trim();

  const getRowNames = (rowData = []) => (Array.isArray(rowData) ? rowData : [])
    .map((row) => row?.[0])
    .filter((value) => value !== undefined && value !== null && normalizePicklistValue(value) !== "");

  const getPersistedSelectedIndexes = (rowData = data) => {
    const selectedValueSet = new Set(getPersistedPicklistValues());

    if(!Array.isArray(rowData) || selectedValueSet.size === 0){
      return [];
    }

    return rowData.reduce((matchedIndexes, row, index) => {
      const rowValue = row?.[0];
      if(selectedValueSet.has(String(rowValue ?? "").trim())){
        matchedIndexes.push(index);
      }
      return matchedIndexes;
    }, []);
  };

  const getPersistedSelectedNames = (rowData = data) => getPersistedSelectedIndexes(rowData)
    .map((index) => rowData?.[index]?.[0])
    .filter((value) => value !== undefined && value !== null && value !== "");

  const mergeUniqueSelections = (storedSelections = [], persistedSelections = []) => Array.from(
    new Set([...(storedSelections || []), ...(persistedSelections || [])])
  );

  const hasTouchedPageInSession = (pageStoreRef, currentPage) => Boolean(pageStoreRef?.current?.[currentPage]);

  const getFinalSelectedPicklistNames = () => {
    const finalSelectionMap = new Map();

    getPersistedPicklistValues().forEach((value) => {
      const normalizedValue = normalizePicklistValue(value);
      if(normalizedValue){
        finalSelectionMap.set(normalizedValue, value);
      }
    });

    Object.keys(touchedBrowsePagesRef.current).forEach((pageKey) => {
      (browsePageNamesRef.current?.[pageKey] || []).forEach((value) => {
        finalSelectionMap.delete(normalizePicklistValue(value));
      });

      (props?.data?.style?.PicklistSelectedAllNames?.[pageKey] || []).forEach((value) => {
        const normalizedValue = normalizePicklistValue(value);
        if(normalizedValue){
          finalSelectionMap.set(normalizedValue, value);
        }
      });
    });

    Object.keys(touchedSearchPagesRef.current).forEach((pageKey) => {
      (searchPageNamesRef.current?.[pageKey] || []).forEach((value) => {
        finalSelectionMap.delete(normalizePicklistValue(value));
      });

      (searchSelectedAllNames?.[pageKey] || []).forEach((value) => {
        const normalizedValue = normalizePicklistValue(value);
        if(normalizedValue){
          finalSelectionMap.set(normalizedValue, value);
        }
      });
    });

    return Array.from(finalSelectionMap.values());
  };

  const getFinalSelectedPicklistData = () => {
    const allData = [];

    Object.keys(touchedBrowsePagesRef.current).forEach((pageKey) => {
      const pageData = props?.data?.style?.PicklistSelectedAllData?.[pageKey] || [];
      if(Array.isArray(pageData)){
        allData.push(...pageData);
      }
    });

    Object.keys(touchedSearchPagesRef.current).forEach((pageKey) => {
      const pageData = searchSelectedAllData?.[pageKey] || [];
      if(Array.isArray(pageData)){
        allData.push(...pageData);
      }
    });

    return allData;
  };

  const getPersistedSearchSelectionState = (rowData = []) => {
    const persistedIndexes = getPersistedSelectedIndexes(rowData);
    const persistedNames = persistedIndexes
      .map((index) => rowData?.[index]?.[0])
      .filter((value) => value !== undefined && value !== null && value !== "");

    return {
      selectedAll: persistedIndexes.length > 0 ? {1: persistedIndexes} : {},
      selectedAllNames: persistedNames.length > 0 ? {1: persistedNames} : {},
    };
  };

  const applySearchResponse = (response) => {
    const pickListData = response?.data?.PickListData || [];
    const persistedSearchState = getPersistedSearchSelectionState(pickListData);
    touchedSearchPagesRef.current = {};
    searchPageNamesRef.current = { 1: getRowNames(pickListData) };

    setData(pickListData);
    setPageNo(1);
    setSearchSelectedAll(persistedSearchState.selectedAll);
    setSearchSelectedAllNames(persistedSearchState.selectedAllNames);
    setSearchMultiSelectDynamic({});
    setIsLastPage(response?.data?.lastpage);
    setPreviousPage(response?.data?.previousPage);
  };

  const applyPageResponse = (response, targetPageNo, lastPage) => {
    const pickListData = response?.data?.PickListData || [];
    const pageNames = getRowNames(pickListData);

    if(isSearchMode){
      searchPageNamesRef.current[targetPageNo] = pageNames;
    } else {
      browsePageNamesRef.current[targetPageNo] = pageNames;
    }
    setData(pickListData);
    setPageNo(targetPageNo);
    setIsLastPage(lastPage ?? false);

    const persistedIndexes = getPersistedSelectedIndexes(pickListData);
    const persistedNames = persistedIndexes
      .map((index) => pickListData?.[index]?.[0])
      .filter((value) => value !== undefined && value !== null && value !== "");

    if(isSearchMode){
      setSearchSelectedAll((prev) => ({
        ...prev,
        [targetPageNo]: hasTouchedPageInSession(touchedSearchPagesRef, targetPageNo)
          ? (prev?.[targetPageNo] || [])
          : mergeUniqueSelections(prev?.[targetPageNo], persistedIndexes)
      }));
      setSearchSelectedAllNames((prev) => ({
        ...prev,
        [targetPageNo]: hasTouchedPageInSession(touchedSearchPagesRef, targetPageNo)
          ? (prev?.[targetPageNo] || [])
          : mergeUniqueSelections(prev?.[targetPageNo], persistedNames)
      }));
    } else {
      props.data.style.PicklistSelectedAll[targetPageNo] = hasTouchedPageInSession(touchedBrowsePagesRef, targetPageNo)
        ? (props?.data?.style?.PicklistSelectedAll?.[targetPageNo] || [])
        : mergeUniqueSelections(
          props?.data?.style?.PicklistSelectedAll?.[targetPageNo],
          persistedIndexes
        );
      props.data.style.PicklistSelectedAllNames[targetPageNo] = hasTouchedPageInSession(touchedBrowsePagesRef, targetPageNo)
        ? (props?.data?.style?.PicklistSelectedAllNames?.[targetPageNo] || [])
        : mergeUniqueSelections(
          props?.data?.style?.PicklistSelectedAllNames?.[targetPageNo],
          persistedNames
        );
    }
  };

  const getCurrentPageSelections = (currentPage = pageNo, rowData = data) => {
    const persistedIndexes = getPersistedSelectedIndexes(rowData);

    // In search mode: fall back to persisted picklist values so any matching
    // search results are preselected until the user explicitly changes them.
    if(isSearchMode){
      if(hasTouchedPageInSession(touchedSearchPagesRef, currentPage)){
        return searchSelectedAll[currentPage] || [];
      }
      return mergeUniqueSelections(searchSelectedAll[currentPage], persistedIndexes);
    }

    // In normal pagination mode: return stored selections, fall back to persisted if not yet touched
    if(hasTouchedPageInSession(touchedBrowsePagesRef, currentPage)){
      return props?.data?.style?.PicklistSelectedAll?.[currentPage] || [];
    }
    return mergeUniqueSelections(props?.data?.style?.PicklistSelectedAll?.[currentPage], persistedIndexes);
  };

  const getCurrentPageSelectionNames = (currentPage = pageNo, rowData = data) => {
    const persistedNames = getPersistedSelectedNames(rowData);

    // In search mode: mirror the persisted fallback used for indexes so name
    // state stays aligned with any preselected search results.
    if(isSearchMode){
      if(hasTouchedPageInSession(touchedSearchPagesRef, currentPage)){
        return searchSelectedAllNames[currentPage] || [];
      }
      return mergeUniqueSelections(searchSelectedAllNames[currentPage], persistedNames);
    }

    // In normal pagination mode: return stored selections, fall back to persisted if not yet touched
    if(hasTouchedPageInSession(touchedBrowsePagesRef, currentPage)){
      return props?.data?.style?.PicklistSelectedAllNames?.[currentPage] || [];
    }
    return mergeUniqueSelections(props?.data?.style?.PicklistSelectedAllNames?.[currentPage], persistedNames);
  };

  const getActiveMultiSelectIndexes = (currentPage = pageNo, rowData = data) => {
    const currentSelections = getCurrentPageSelections(currentPage, rowData);
    return Array.isArray(currentSelections) ? currentSelections : [];
  };

  useEffect(() => {
      
      if( props?.data?.style?.PicklistSelected !== undefined ){
        setRowSelect( props.data.style.PicklistSelected);
        setSelectedName( props?.data?.style?.Picklist)
      }

      var remainingURL = "/pickListView/populatePicklistDataFromDB";


      var jsonToSend = {
        columnId:colId.current,
        column:props.columnId, // it is column id of table when picklist is opened in table control
        gdtoken: contexts.gdtoken,
        controlId : props.data.id || props.id,
        batchSize: parseInt(props?.data?.style?.BatchSize),
        pageNo: pageNo,
      };

      if(data && column){
        if((data.length < 1)  && (column.length < 1)){
        axios.post(remainingURL, jsonToSend, {withCredentials:true})
        .then((response) =>{
          const dataResponse=response?.data ? response : {};
          const newDataResponse = dataResponse ? dataResponse.data ?  dataResponse.data : {} : {};
          setColumn(newDataResponse?.PickListColumn);
          setPages(newDataResponse?.PickListData?.length);
          setIsLastPage(newDataResponse?.lastPage);
          setColumnWidthMap(newDataResponse?.WidthMap);

          setDefaultColumnValue(newDataResponse?.defaultColumnValue);
          setEnableColumnMap(newDataResponse?.enableColumnMap);

          var hiddenColumnList = [];

          if(newDataResponse?.PickListColumn?.length!==0){

            Object.values(newDataResponse?.PickListColumn).forEach((key,index)=>{
              if(key === "HiddenPicklistColumn"){
                hiddenColumnList.push(index);
              }

            const matchedField = props?.data?.outputFields?.find(
              (field) => field?.picklist_variable?.toLowerCase() === key?.toLowerCase()
            );

            if (matchedField?.hidden === true) {
              hiddenColumnList.push(index);
            }
            })

          }

          setHiddenColumnIndexList(hiddenColumnList);

        var selctedColumnList = [];
          
          if(newDataResponse?.PickListColumn?.length!==0 && newDataResponse?.enableColumnMap?.size!==0){

            Object.values(newDataResponse?.PickListColumn).forEach((key,index)=>{
              if(newDataResponse?.enableColumnMap[key] === false){
                selctedColumnList.push(index);
              }
            })
          }
          browsePageNamesRef.current[pageNo] = getRowNames(newDataResponse?.PickListData);
          setData(newDataResponse?.PickListData);

          setColumnDropdown(selctedColumnList);
        

          setPages(newDataResponse?.Pages);
          // if(props?.data?.value && props?.data?.style?.AllowMultipleSection === "true" && props?.data?.style?.AllowTyping === "true"){
          //   // let val1 = props?.data?.value?.split(",");
            
          //   // // Convert Picklists into array
          //   // let picklistsArr = props.data.style?.Picklists.split(",");

          //   // // ✅ Keep only intersection
          //   // let intersection = picklistsArr.filter(item => val1?.includes(item));

          //   // // Update Picklists
          //   // props.data.style.Picklists = intersection.join(",");

          //   // // Update PicklistSelectedAllNames
          //   // Object.keys(props.data.style.PicklistSelectedAllNames).forEach(key => {
          //   //     props.data.style.PicklistSelectedAllNames[key] = props.data.style.PicklistSelectedAllNames[key].filter(item => val1?.includes(item));
          //   // });

          //   // // Update PicklistSelectedAll (keep only those indices that match names length)
          //   // Object.keys(props.data.style.PicklistSelectedAll).forEach(key => {
          //   //     // ⚠️ here I'm keeping numeric arrays **as-is**, but trimming to the same length as names
          //   //     let allowedLength = props.data.style.PicklistSelectedAllNames[key].length;
          //   //     props.data.style.PicklistSelectedAll[key] = props.data.style.PicklistSelectedAll[key].slice(0, allowedLength);
          //   // });
          //   // filterPicklistsByAllowed(props?.data?.style, props?.data?.value);
          // }
        
          if(newDataResponse?.Rows === 0) {
            setEmpty(true);
          } else {
            setEmpty(false);
          }     

        }).catch(function (error) {
            console.log(error);
        });
        }
      }


  }, []);

  useEffect(() => {
    if(style?.AllowMultipleSection === "true"){
      setSelected(getCurrentPageSelections(pageNo, data));
      return;
    }

    const persistedSingleValue = getPersistedSingleValue();
    if(!persistedSingleValue || !Array.isArray(data) || data.length === 0){
      setSelectedIndex(-1);
      return;
    }

    const matchedIndex = data.findIndex((row) => String(row?.[0] ?? "").trim() === persistedSingleValue);

    if(matchedIndex > -1){
      setRowSelect(matchedIndex);
      setSelectedIndex(matchedIndex);
      setSelectedName(data?.[matchedIndex]?.[0]);
      props.data.style.PicklistSelectedAllData[pageNo] = data?.[matchedIndex];
    } else {
      setSelectedIndex(-1);
    }
  }, [data, pageNo, isSearchMode, style?.AllowMultipleSection]);



  const handlePrevious2 = () => {
   
    if(pageNo > 1){
    var remainingURL = "/pickListView/previousPage";
    var jsonToSend = {
        gdtoken:contexts.gdtoken,
        controlId : props.data.id,
        columnId: props?.columnId,
        batchSize: parseInt(props.data.style.BatchSize),
        pageNo: pageNo-1,
        searchString: inputRef.current?.value,
        //searchString: search,
        column: colId.current
    };
    axios.post(remainingURL, jsonToSend, {withCredentials:true})
    .then((response) =>{
       applyPageResponse(response, pageNo-1, false);
    }).catch(function (error) {
      console.log(error);
    });
  }

} 
  const handleNext2 = () => {

        if(pages !== pageNo ){
        var remainingURL = "/pickListView/nextPage";
        var jsonToSend = {
            gdtoken:contexts.gdtoken,
            controlId : props.data.id,
            batchSize: parseInt(props.data.style.BatchSize),
            pageNo: pageNo+1,
            searchString: inputRef.current?.value,
           // searchString: search,
            columnId:props?.columnId,
            column:colId.current,
        };
        axios.post(remainingURL, jsonToSend, {withCredentials:true})
        .then((response) =>{
           applyPageResponse(response, pageNo+1, response?.data?.lastpage);
           
        }).catch(function (error) {
          console.log(error);
        });
      }
  
  }  
  const handleSearchClick = (e) => {
    // Enter search mode: clear search-specific selections so original page
    // selections don't bleed into search-result pages.
    // Preserve any names that are already in rawValueList before clearing.
    setIsSearchMode(true);
    setSearch(inputRef.current?.value);
    setPageNo(1);
      var remainingURL = "/pickListView/globalSearch";
    var jsonToSend = {
      gdtoken:contexts.gdtoken,
     batchSize: parseInt(props.data.style.BatchSize), 
      controlId : props.data.id,
      searchString: inputRef.current?.value,
      column:colId.current,
      columnId: props?.columnId ? props?.columnId : ""
    };

   
    axios.post(remainingURL, jsonToSend, {withCredentials:true})
    .then((response) =>{
      applySearchResponse(response);
  
    }).catch(function (error) {
        console.log(error);
    });
  }

  const handleSearch2 = (e) => {
      if(e.keyCode === 13){
      setIsSearchMode(true);
      setSearch(e.target.value);
      setPageNo(1);
      var remainingURL = "/pickListView/globalSearch";
    var jsonToSend = {
      gdtoken:contexts.gdtoken,
      controlId : props.data.id,
      searchString: e.target.value,
      batchSize: parseInt(props.data.style.BatchSize),
      column:colId.current,
      columnId: props?.columnId ? props?.columnId : ""
    };

   
    axios.post(remainingURL, jsonToSend, {withCredentials:true})
    .then((response) =>{
      applySearchResponse(response);
  
    }).catch(function (error) {
        console.log(error);
    });
  }
  if(e.key === "Backspace" && e?.target?.value?.length === 1){
    setIsSearchMode(true);
    setSearch(e.target.value);
    setPageNo(1);
    var remainingURL = "/pickListView/globalSearch";
  var jsonToSend = {
    gdtoken:contexts.gdtoken,
    controlId : props.data.id,
    searchString: e.target.value,
    column:colId.current,
    columnId: props?.columnId ? props?.columnId : "",
    batchSize: parseInt(props.data.style.BatchSize)
  };

 
  axios.post(remainingURL, jsonToSend, {withCredentials:true})
  .then((response) =>{
    applySearchResponse(response);

  }).catch(function (error) {
      console.log(error);
  });
  }
  }
  function getPicklistColumnIndex(columnData){
    if(currentAdvanceListviewStateJson){
      for(let colIndex = 0; colIndex < currentAdvanceListviewStateJson?.columnList?.length; colIndex++){
        if(currentAdvanceListviewStateJson?.columnList[colIndex]?.style.complexFieldName === columnData.dataclass){
          return colIndex;
        }
      }
    }else if(subFormListviewJson){
      for(let colIndex = 0; colIndex < subFormListviewJson?.columnList?.length; colIndex++){
        if(subFormListviewJson?.columnList[colIndex]?.elementJson?.id === columnData.id){
          return colIndex;
        }
      }
    }
  }

  const handleSelect = (e) => { 
    if(props.fromTable){
      if(openCanvasForPreview!=="showDataAdditonSection" && props.data.elem_type!=="picklist")
    {
      if(props?.data?.style?.AllowMultipleSection === "true")
        {
          const list = getFinalSelectedPicklistNames();
          props.data.style.Picklists = list.join(",");
          props?.handleRowData(props.data.style.Picklists);
          //updateValue(props?.data?.id, props.data.style["Picklists"], false)
        }
      if(props?.handleRowData !== undefined && props?.data?.style?.AllowMultipleSection !== "true")
      props?.handleRowData(data[rowSelect][0]);
      if(props.handleOnChangeTable !== undefined ){
        if(props?.data?.style?.AllowMultipleSection === "true")
        {
          props.handleOnChangeTable(props.rowIndex,props.dataKey,props.data.style.Picklists)
          if(window.allowSelection && window.allowSelection())
            {
                window.postHookPickListOk(getFinalSelectedPicklistData(),getHooksId(props?.data),getActiveMultiSelectIndexes(),props?.rowIndex,props.columnId)
                functions.updateJSON();
            }
            props.setSelectedValuesTable(getFinalSelectedPicklistNames())
        }
        else{
          props.handleOnChangeTable(props.rowIndex,props.dataKey,data[rowSelect][0])
        }
      }
    
      props.onClose2()
   }
    }else{
      if(style?.AllowMultipleSection === "false") {

        props.data.style.Picklist = selectedName;
        props.data.style.PicklistSelected = rowSelect;
        var jsonToSend = { 
          "attrValue": data[rowSelect][0], 
          "attrType": "text",
          "attrName": props?.data?.dataclass || props?.data?.id
      };

      sendRequestToUpdateValue(jsonToSend, props?.data?.frameIndex, props?.containerId).then((response)=>{
        if(response && response.data && response.data.status === "-2"){
          setAlertData({
            open: true,
            showConfirm: "showNotification",
            alertType: "error",
            alertContentKey: "INVALID_DATA_MESSAGE",
            autoHideDuration: 4000
          })
        }
        else{
        if(props.data.style.Picklist && props.data.style["Picklist"]) {
          props.data.value = props.data.style["Picklist"]
          if (openCanvasForPreview === "advanceListviewPopupInPreview"){
            updateValue(props?.data?.id, props.data.style["Picklist"], false,props?.data)
          }
          else if(openCanvasForPreview === "showDataAdditonSection" || props.data?.isAboveListview){
            updateValue(props?.data?.id, props.data.style["Picklist"], false,props?.data)
          }
          else{
            updateValue(props?.data?.id, props.data.style["Picklist"],true,props?.data)
          }
          if ((openCanvasForPreview === "showDataAdditonSection" || props.data?.isAboveListview) && props?.data?.style?.hasOwnProperty("ColumnName")) {
            dispatch(updateGridContexts({key: props.containerId, name: "listviewClearState", value: false}));
            const tableId = props.data?.id?.split("_")?.[0];
            let currentListviewColumnInfo = listviewColumnInfo.get(tableId);
            if(!currentListviewColumnInfo){
              listviewColumnInfo.set(tableId,new Map());  
              currentListviewColumnInfo = listviewColumnInfo.get(tableId);
            }
            currentListviewColumnInfo.set(props.data.style.ColumnName, props.data.value);
            // dispatch(setMap(tableId, { [props.data.style.ColumnName]: props.data.value }));

            // if(props.data && props.data.event && props.data.event.Events && props.data.event.Events.Change){
            //   triggerEventCalls({type:"change"},{id:props.id},props.data.event,props.data.elem_type,showAlertConfirmNotifications, reduxContexts, props?.containerId,props?.data,"Change");
            // }
          }
        }
        if(window.postChangeEventHandler && response?.data?.responseData){
          window.postChangeEventHandler(props.data.dataclass || props.data.id, response?.data?.responseData)
          // if(functions?.render){
            functions?.updateJSON()
          // }
        }
        if(response?.data?.APIData){
          renderExecuteServerEventAPIData({outputArray:response?.data?.APIData,sync: true, renderFlag: true}, props?.containerId);
          // if(functions?.render){
            functions?.updateJSON()
          // }
        }
        if(window.postHookPickListOk)
          {
            if(style.AllowMultipleSection === "false") {
              let cols = data[rowSelect];
              if(props.fromTable) {
                window.postHookPickListOk(cols,getHooksId(props?.data),props.rowIndex,props.columnId);
              }
              else {
                window.postHookPickListOk(cols,getHooksId(props?.data),window.currentRowIndexListview,getPicklistColumnIndex(props?.data));
              }
            } else {
              const multiSelectData = getFinalSelectedPicklistData();
              if(props.fromTable) {
                window.postHookPickListOk(multiSelectData,getHooksId(props?.data),props.rowIndex,props.columnId);
              }
              else {
                window.postHookPickListOk(multiSelectData,getHooksId(props?.data),window.currentRowIndexListview,getPicklistColumnIndex(props?.data));
              }
            }
            functions.updateJSON();
          }
        if(props?.data?.outputFields?.length > 0){
          let obj1 = {}
          let arr1 = []
          let obj2 = {}
          props?.data?.outputFields?.map(item => {
            let index = -1
            index = column?.findIndex(col => col?.toLowerCase() === item?.picklist_variable?.toLowerCase())
            if(index > -1){
              obj1[`${item?.picklist_map_field}`] = data[rowSelect][index]
              if((openCanvasForPreview === "showDataAdditonSection" || props.data?.isAboveListview) && props.data.style.hasOwnProperty("ColumnName")){
                arr1.push(item?.picklist_map_field?.split(".")?.[1])
              }
            }
          })
          if(arr1.length){
            const tableId = props.data?.id?.split("_")?.[0];
            const listviewJson = recursiveJsonReader1(formState2, tableId, "")
              console.log("naiyo3", listviewJson, tableId)
            for(let child of listviewJson?.listviewFrameLayoutJson?.children?.[0]?.children?.[0]?.children?.[0]?.children){
              const controlJson = child?.children?.[0];
                console.log("naiyo4", controlJson, child)
              if(controlJson?.style?.complexFieldName){
                if(arr1?.includes(controlJson?.style?.complexFieldName)){
                  obj2[`${controlJson?.id}`] = obj1[`${listviewJson.dataclass}.${controlJson?.style?.complexFieldName}`]
                }
              }
            }
          }
          functions.setValues(arr1.length ? obj2 : obj1, true)          
          functions.updateJSON()
        }
        }
      })
      if(props.setPicklistValue){
        props.setPicklistValue(data[rowSelect][0])
      }

   
      } else {
        const list = getFinalSelectedPicklistNames();
        props.data.style.Picklists = list.join(",");
        // Merge search-mode dynamic picklist data into style so outputFields
        // mapping (which reads multiSelectDynamicPicklist) picks up search selections
        if(Object.keys(searchMultiSelectDynamic).length > 0){
          if(!props.data.style.multiSelectDynamicPicklist) props.data.style.multiSelectDynamicPicklist = {};
          for(let key of Object.keys(searchMultiSelectDynamic)){
            // Use a key that won't collide with original page numbers
            const mergeKey = `s_${key}`;
            props.data.style.multiSelectDynamicPicklist[mergeKey] = searchMultiSelectDynamic[key];
          }
        }
        var jsonToSend = { 
          "attrValue": props.data.style.Picklists, 
          "attrType": "text",
          "attrName": props?.data?.dataclass || props?.data?.id
      };
      sendRequestToUpdateValue(jsonToSend, props?.data?.frameIndex, props.containerId).then((response)=>{
        if(response && response.data && response.data.status === "-2"){
          setAlertData({
            open: true,
            showConfirm: "showNotification",
            alertType: "error",
            alertContentKey: "INVALID_DATA_MESSAGE",
            autoHideDuration: 4000
          })
        }
        else{
        if(props.data.style && props.data.style.Picklists && props.data.style["Picklists"]) {
          props.data.value = props.data.style["Picklists"]
          if (openCanvasForPreview === "advanceListviewPopupInPreview"){
            updateValue(props?.data?.id, props.data.style["Picklists"], false,props?.data)
          }
          else if(openCanvasForPreview === "showDataAdditonSection" || props.data?.isAboveListview){
            updateValue(props?.data?.id, props.data.style["Picklists"], false,props?.data)
          }
          else{
            updateValue(props?.data?.id, props.data.style["Picklists"],true,props?.data)
          }
          if ((openCanvasForPreview === "showDataAdditonSection" || window.isAboveSection || props.data.isAboveListview) && props.data.style.hasOwnProperty("ColumnName")) {
            dispatch(updateGridContexts({key: props.containerId, name: "listviewClearState", value: false}));
            const tableId = props.data?.id?.split("_")?.[0];
            let currentListviewColumnInfo = listviewColumnInfo.get(tableId);
            if(!currentListviewColumnInfo){
              listviewColumnInfo.set(tableId,new Map());  
              currentListviewColumnInfo = listviewColumnInfo.get(tableId);
            }
            currentListviewColumnInfo.set(props.data.style.ColumnName, props.data.value);
          }
        }
        if(window.postChangeEventHandler && response?.data?.responseData){
          window.postChangeEventHandler(props.data.dataclass || props.data.id, response?.data?.responseData)
        }
        if(response?.data?.APIData){
          renderExecuteServerEventAPIData({outputArray:response?.data?.APIData,sync: true, renderFlag: true}, props?.containerId);
        }
        if(window.postHookPickListOk)
          {
            if(style.AllowMultipleSection === "false") {
              let cols = data[rowSelect];
              if(props.fromTable) {
                window.postHookPickListOk(cols,getHooksId(props?.data),props.rowIndex,props.columnId);
              }
              else {
                window.postHookPickListOk(cols,getHooksId(props?.data),window.currentRowIndexListview,getPicklistColumnIndex(props?.data));
              }
            } else {
              const multiSelectData = getFinalSelectedPicklistData();
              if(props.fromTable) {
                window.postHookPickListOk(multiSelectData,getHooksId(props?.data),props.rowIndex,props.columnId);
              }
              else {
                window.postHookPickListOk(multiSelectData,getHooksId(props?.data),window.currentRowIndexListview,getPicklistColumnIndex(props?.data));
              }
            }
            functions.updateJSON();
            }
          if(props?.data?.outputFields?.length > 0){
            let obj1 = {}
            let arr1 = []
            let obj2 = {}
            let arr2 = []
            let flag = true
            props?.data?.outputFields?.map(item => {
              let index = -1
              for (let key in props?.data?.style?.multiSelectDynamicPicklist) {
                // console.log(`Category: ${key}`);  // Access the object keys like 'fruits', 'vegetables', etc.
                for (let item of props?.data?.style?.multiSelectDynamicPicklist[key]) {
                  if(arr2.length === 0)
                  arr2.push(...item);
                  flag = false
                  break;
                }
                if(!flag){
                  break;
                }
              }
              index = column?.findIndex(col => col?.toLowerCase() === item?.picklist_variable?.toLowerCase())
              if(index > -1){
                obj1[`${item?.picklist_map_field}`] = arr2[index]
                if((openCanvasForPreview === "showDataAdditonSection" || props.data?.isAboveListview) && props.data.style.hasOwnProperty("ColumnName")){
                  arr1.push(item?.picklist_map_field?.split(".")?.[1])
                }
              }
            })
            if(arr1.length){
              const tableId = props.data?.id?.split("_")?.[0];
              const listviewJson = recursiveJsonReader1(formState2, tableId, "")
              console.log("naiyo3", listviewJson, tableId)
              for(let child of listviewJson?.listviewFrameLayoutJson?.children?.[0]?.children?.[0]?.children?.[0]?.children){
                const controlJson = child?.children?.[0];
                console.log("naiyo4", controlJson, child)
                if(controlJson?.style?.complexFieldName){
                  if(arr1?.includes(controlJson?.style?.complexFieldName)){
                    obj2[`${controlJson?.id}`] = obj1[`${listviewJson.dataclass}.${controlJson?.style?.complexFieldName}`]
                  }
                }
              }
            }
            if((props?.data?.style?.multiSelectDynamicPicklist && Object.keys(props?.data?.style?.multiSelectDynamicPicklist)?.length !== 0 && arr2?.length !== 0) || (arr1?.length !== 0)){
              functions.setValues(arr1.length ? obj2 : obj1, true)
              functions.updateJSON()
            }
          }
          }
        })
      if(props.setPicklistValue){
        props.setPicklistValue(data[rowSelect][0])
      }
  
      }
    }
    
    setTimeout(() => {
    const selectedAllData = style?.AllowMultipleSection === "false" ? data[rowSelect] : getFinalSelectedPicklistData();
    onClose(data, rowSelect, selected, selectedAllData);

    }, 300);

    e.preventDefault();
  };

  const handleRowsSelect = (event, row, selectedName) => {
    let newSelected = [];
    if(!props?.data?.style?.PicklistSelectedAll)
    {
      props.data.style.PicklistSelectedAll = {};
    }
    if(props?.data?.outputFields?.length > 0 && props?.data?.style?.AllowMultipleSection === "true" && !props?.data?.style?.multiSelectDynamicPicklist){
      props.data.style.multiSelectDynamicPicklist = {};
    }

    // In search mode, read from isolated search-state so original page
    // selections (keyed by the same pageNo integers) don't bleed in.
    const currentPageSelections = getCurrentPageSelections(pageNo, data);

    newSelected = newSelected.concat(currentPageSelections);
    if(newSelected.includes(row)){
      const index = newSelected.indexOf(row);
      if (index > -1) {
        newSelected.splice(index, 1);
      }
    } else {
      newSelected = newSelected.concat(row);
    }

    if(isSearchMode){
      touchedSearchPagesRef.current[pageNo] = true;
    } else {
      touchedBrowsePagesRef.current[pageNo] = true;
    }

    setSelected(newSelected);
    const newSelectedNames = newSelected
      .map((selectedIndex) => data?.[selectedIndex]?.[0])
      .filter((value) => value !== undefined && value !== null && normalizePicklistValue(value) !== "");

    const newSelectedData = newSelected.map((selectedIndex) => data?.[selectedIndex]).filter(Boolean);

    // Write to the correct store depending on mode
    if(isSearchMode){
      setSearchSelectedAll(prev => ({...prev, [pageNo]: newSelected}));
      setSearchSelectedAllNames(prev => ({...prev, [pageNo]: newSelectedNames}));
      setSearchSelectedAllData(prev => ({...prev, [pageNo]: newSelectedData}));
    } else {
      props.data.style.PicklistSelectedAll[pageNo]=newSelected;
      props.data.style.PicklistSelectedAllNames[pageNo]=newSelectedNames;
      props.data.style.PicklistSelectedAllData[pageNo]=newSelectedData;
    }

    if(props?.data?.outputFields?.length > 0 && props?.data?.style?.AllowMultipleSection === "true"){
      const currentDynamic = isSearchMode
        ? (searchMultiSelectDynamic[pageNo] || [])
        : (props.data.style.multiSelectDynamicPicklist[pageNo] || []);
      let newSelected1 = [...currentDynamic];
      if(newSelected1.includes(data[row])){
        const index = newSelected1.indexOf(data[row]);
        if (index > -1) {
          newSelected1.splice(index, 1);
        }
      } else {
        newSelected1.push(data[row]);
      }
      if(isSearchMode){
        setSearchMultiSelectDynamic(prev => ({...prev, [pageNo]: newSelected1}));
      } else {
        props.data.style.multiSelectDynamicPicklist[pageNo]=newSelected1;
      }
    }
  };

  const handleRowSelect = (event, row, index) => {
    setRowSelect(row);
    setSelectedName(data[index][0]);
    props.data.style.PicklistSelectedAllData[pageNo] = data[index];
    setSelectedIndex(index)
  }

  

  const handleSelectAll = (event) => {
    if(check === false){
      let list = {};
      for(let i=1; i<=pages; i++){
        let arr = [];
        for(let j=0; j<=props.data.style.BatchSize; j++) arr.push(j);
        list[i] = arr;
      }
      props.data.style.PicklistSelectedAll = list;
      setSelected(list[pageNo]);
      props.data.style.PicklistSelectedAllData[pageNo] = list[pageNo].map((idx) => data?.[idx]).filter(Boolean);
      touchedBrowsePagesRef.current[pageNo] = true;
    } else {
      props.data.style.PicklistSelectedAll = {};
      props.data.style.PicklistSelectedAllData = {};
      setSelected([]);
    }
    setCheck(!check);
  }

  function handleClose2() {
    props.onClose2();
    if(window.postHookPickListCancel){
      window.postHookPickListCancel(props.data.id); 
      functions.updateJSON();
    }
  }



 function toggleCheckbox(index)
 {
  
 }

 function handleEscapeKey(e){
   if(e.code === "Escape"){
      handleClose2()
   } 
  }
  useEffect(()=>{
    document.getElementById("picklistPopupId")?.focus();
    
   },[])

   const handleColId = (e) => {
    setColIdState(e.target.value)
    colId.current = e.target.value;
  }

   const handleOnChange = useCallback(debounce((e) => {
    if(e.target.value?.length >= 3){
      setIsSearchMode(true);
      
      var remainingURL = "/pickListView/globalSearch";
      setPageNo(1);
    var jsonToSend = {
      gdtoken:contexts.gdtoken,
      controlId : props.data.id,
      searchString: e.target.value,
      column:colId.current,
      columnId: props?.columnId ? props?.columnId : ""
    };

    axios.post(remainingURL, jsonToSend, {withCredentials:true})
    .then((response) =>{
      applySearchResponse(response);
  
    }).catch(function (error) {
        console.log(error);
    });
    }
  }, 200, {leading: true, trailing: false, maxWait: 200}), []);

  // Determine if next button should be disabled
  const isNextDisabled = () => {
    // Always disable if no data or builder mode is invalid
    if (data?.length === 0 || (builderMode === undefined && builderMode !== "application")) {
      return true;
    }
    // In search mode: disable if data length is less than batch size (last page of search)
    if (isSearchMode) {
      return data?.length < parseInt(props.data.style.BatchSize);
    }
    // Normal pagination mode: disable if on last page
    return pageNo === pages || isLastPage;
  };

  // Determine if previous button should be disabled
  const isPreviousDisabled = () => {
    // Always disable if no data or builder mode is invalid
    if (data?.length === 0 || (builderMode === undefined && builderMode !== "application")) {
      return true;
    }
    // Disable if on first page
    return pageNo === 1;
  };

  const PageNavButtonGroup = 
    window?.psh_configs?.selectedLanguage==="ar" || window?.psh_configs?.selectedLanguage==="ar-SA" ?
      <>
        <button  id={props?.data?.id + "_nextpage"} variant="outlined" size="small" className={classes.rightArrowIcon1}
          onClick={() => !isNextDisabled() && handleNext2()}
          disabled={isNextDisabled()}
        >
            {isNextDisabled() ? <ChevronRightIcon color="disabled"/> : <ChevronRightIcon/>}
            <p style={{display:"none"}}>Next</p>
        </button>
        <button  id={props?.data?.id + "_previouspage"} variant="outlined" size="small" className={classes.leftArrowIcon1} onClick={() => !isPreviousDisabled() && handlePrevious2()}
          disabled={isPreviousDisabled()}  
        >
            {isPreviousDisabled() ? <ChevronLeftIcon color="disabled"/> : <ChevronLeftIcon/>}
            <p style={{display:"none"}}>Previous</p>
        </button>
      </>
      :
      <>
        <button id={props?.data?.id + "_previouspage"} variant="outlined" size="small" className={classes.leftArrowIcon1} onClick={() => !isPreviousDisabled() && handlePrevious2()}
          disabled={isPreviousDisabled()}  
        >
            {isPreviousDisabled() ? <ChevronLeftIcon color="disabled"/> : <ChevronLeftIcon/>}
            <p style={{display:"none"}}>Previous</p>
        </button>
        <button id={props?.data?.id + "_nextpage"} variant="outlined" size="small" className={classes.rightArrowIcon1}
          onClick={() => !isNextDisabled() && handleNext2()}
          disabled={isNextDisabled()}
        >
            {isNextDisabled() ? <ChevronRightIcon color="disabled"/> : <ChevronRightIcon/>}
            <p style={{display:"none"}}>Next</p>
        </button>
      </>

  const currentPageSelectedIndexes = getCurrentPageSelections(pageNo, data);

  let headerTitle = props?.data?.style?.["PopupTextTouched"] || props?.data?.style?.["PopupText"] || props?.data?.style?.["Label"];
  if(window?.picklistHeaderTitleType && typeof window?.picklistHeaderTitleType === "function") {
    const customTitleType = window?.picklistHeaderTitleType(props?.data?.id);

    if(customTitleType === "customPopupText") {
      headerTitle = props?.data?.style?.["PopupTextTouched"];
    } else if(customTitleType === "popupText") {
      headerTitle = props?.data?.style?.["PopupText"];
    } else if(customTitleType === "label") {
      headerTitle = props?.data?.style?.["Label"];
    }
  }

  return (
    <div tabIndex="0" onKeyDown={(e) => handleEscapeKey(e)} id="picklistPopupId">
      
    <Dialog  classes={{paper:classes.dialog}}  open={open}
    enforceFocus={false}
    onClose={handleClose2}
    >
     
        
        <DialogTitle classes={{root:classes.dialogTitle}}>
            <div className={classes.dialogHead} >
                <div 
                  title={headerTitle} 
                  id={props.data.id+'_picklistHeader'} 
                  className={isTabletOrMobile ? classes.dialogHead11 : classes.dialogHead1}
                >
                  {headerTitle}
                </div>
                <div className={classes.dialogHead2}>
                    <Tooltip classes={{root:classes.closeIcon}} title="Close">  
                        <img id={props?.data?.id + "_closeicon"} style={{marginRight:"0px" ,marginTop: "5px"}} src={require("../../../../Icons/PickListIcons/Cancel.svg").default} onClick = {handleClose2} className={classes.dialogHeadIcon} alt='Cancel Icon' tabIndex="0"/>
                    </Tooltip>
                </div>
            </div>
            
        </DialogTitle>
        
        <Divider className={classes.divider}/>

        <DialogContent classes={{root:classes.dialogContent}} >
            <DialogContentText>
            <div className={classes.dialogContentHead} >
            {isMobileDisplay && <div className={classes.pagingButtonGroup}> {PageNavButtonGroup} </div> }
            <div className={classes.dialogHead2} style = {{
              justifyContent: isMobileDisplay ? "center" : "",
              gap: isMobileDisplay ? "8px" : "",
              padding: isMobileDisplay ? "0 8px" : "",
            }}>
                <Select 
                  onChange={handleColId} 
                  label={"Columns"}
                  className={classes.allColumns}
                  value={colIdState}
                  variant='outlined'
                  MenuProps={{
                    classes: {
                      paper: classes.menuRoot
                    },
                  }}
                   >
                    <MenuItem id={props?.data?.id + "_allcolumns"} value={-1}>{t("All Columns")}</MenuItem>
                   {
                        column && column.length > 0 && column.map((col,index) => {
                          return (
                          (col!== "HiddenPicklistColumn" && !columnDropdown.includes(index) && col===defaultColumnValue) ?
                            <MenuItem id={props?.data?.id + "_option_" + index} key={index} value={index}>
                                {col}
                            </MenuItem>
                            :
                            (col!=="HiddenPicklistColumn" && !columnDropdown.includes(index))
                            ?
                            <MenuItem id={props?.data?.id + "_option_" + index} key={index} value={index}>
                            {col}
                              </MenuItem>
                              :
                              null
                          
                          )})
                  }
                </Select>
                <span style={{display:"flex", "border-top-right-radius": "3px", "border-bottom-right-radius": "3px"}} className={`${classes.searchBox} search`}  >
                    <input aria-label={"Super Search"} ref={inputRef} id={props?.data?.id + "_superSearch"} type="text" className={classes.searchInput} placeholder={t("Search")} onKeyDown={(e) => handleSearch2(e)} 
                      onChange={handleOnChange} 
                     />
                    <span id={props?.data?.id + "_searchicon"} style={{marginTop:"3px",marginRight:"16px",marginLeft:window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA"? "16px":""
}} className={classes.searchIcon} onClick={handleSearchClick} >
                      <img src={require("../../../../Icons/PickListIcons/Search.svg").default} alt='Search Icon' tabIndex="0" />
                    </span>
                </span>

                { !isMobileDisplay && PageNavButtonGroup }
            </div>
            </div>

           {(style.AllowMultipleSection === "false") ?
         
          <TableContainer classes={{root:classes.tableContainer}}>
    
            <Table stickyHeader classes={{root:classes.table}}  size="small">
                <TableHead classes={{root:classes.tableHead}}>
                  <TableRow  classes={{root:classes.tableHeadRow}}>
                    {columnWidthMap?.size!==0 && column?.map((col, index) => (
                      <>
                      {!hiddenColumnIndexList.includes(index) ?

                      <TableCell key={index} tabIndex="0"
                      classes={{root:classes.tableHeadCell}}
                      style={{width : columnWidthMap[col] + "px"}}
                      >
                        {col} 
                      </TableCell> :

                      null} 
                      </>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                    {empty===false && data?.length > 0 ?
                    data && data.map((row, index) => {
                    return( 
                      <TableRow id={props?.data?.id + "_row_" + index} hover 
                      onClick={(e) => handleRowSelect(e,index,index)} key={index} classes={{root:classes.tableBodyRow}} style={{backgroundColor:  (index === selectedIndex)? "#0072C60F":"#FFFFFF"}} >
                        {  row.map((cell, index1) =>{
                        return (
                          <>
                          {!hiddenColumnIndexList.includes(index1) ?
                          <>
                          <TableCell key={index1} tabIndex="0" 
                          onKeyDown={(e) => e.key === "Enter" && handleRowSelect(e, index, index)}
                          classes={{root:classes.tableBodyCell}}>
                           {cell}
                          </TableCell>
                          </> : null
                        }
                          </>
                         )})}              
                      </TableRow>
                    );
                    }):
                    <TableRow  classes={{root:classes.tableRow}}>
                      <TableCell tabIndex="0" colSpan={column?.length} style={{textAlign:"center"}} classes={{root:classes.tableBodyCell}}>
                        <img style={{marginLeft: window?.psh_configs?.selectedLanguage==="ar" || window?.psh_configs?.selectedLanguage==="ar-SA" ? "unset" : "45%", marginRight: window?.psh_configs?.selectedLanguage==="ar" || window?.psh_configs?.selectedLanguage==="ar-SA" ? "45%" : "unset" , display:"block"}} src={require(`../../../../Icons/Group 73477.svg`).default} alt='Table Row Icon'/>
                        {t('No_Records')}
                        </TableCell>
                      </TableRow>
                    }
                </TableBody>
            </Table>
        </TableContainer>     

      
        :  
          
         <TableContainer  classes={{root:classes.tableContainer}} >
          <Table classes={{root:classes.table}} size="small">
                 <TableHead stickyHeader>
                   <TableRow id={props?.data?.id + "selectall"} classes={{root:classes.tableHeadRow}} onClick={(event) => handleSelectAll(event)} style={{backgroundColor: check ? "#0072C60F":"#FFFFFF"}}>
                     <TableCell tabIndex="0" classes={{root:classes.tableCheckCell}}> 
                      </TableCell>
                     {column?.map((col, index) => (
                        <>
                          {!hiddenColumnIndexList.includes(index) ?
                          <>
                       <TableCell tabIndex="0" key={index} classes={{root:classes.tableHeadCell}} >
                           {col} 
                       </TableCell> 
                       </> : null
                       }
                       </>
                     ))}
                   </TableRow> 
                 </TableHead>
                 <TableBody >
                    {data?.map((row,index) => (
                       <TableRow id={props?.data?.id + "_rows_" + index} key={index} onClick={(event) => handleRowsSelect(event, index, row[0])} style={{backgroundColor: currentPageSelectedIndexes?.includes(index) ? "#0072C60F":"#FFFFFF"}}  classes={{root:classes.tableBodyRow}}>
                     <TableCell tabIndex="0"  classes={{root:isSafariBrowser()? classes.tableCheckCellSafari  :classes.tableCheckCell}}> <input
                     aria-label={props?.data?.style?.Label||"Browser Value"} type="checkbox" id={"check"+index} onClick={() => toggleCheckbox(index)} checked={currentPageSelectedIndexes?.includes(index) ? true : false} style={{border: "1px solid #C4C4C4", borderRadius: "2px", opacity: 1}} /> </TableCell>
                           {row?.map((cell, index1) => (
                            <>
                          {!hiddenColumnIndexList.includes(index1) ?
                          <>
                               <TableCell key={index1}
                              //  onKeyDown={(e) => e.key === "Enter" && handleRowSelect(e, row[0], index)}
                                classes={{root:classes.tableBodyCell}} >{cell}</TableCell>
                                </> : null 
                                }
                                </>
                           ))}                        
                     </TableRow>    
                     ))}
                </TableBody>
             </Table>
         </TableContainer>  }
      


        </DialogContentText>   
        </DialogContent>

        <DialogActions classes={{root:classes.dialogActions}}>
            <Button disableFocusRipple
            id={props?.data?.id + "cancel"}
                disableRipple
                tabIndex={0}
                  className={`formBuilder-MuiButton-outlined`} classes={{root:classes.btn1,label:classes.btnlabel}} size="small" variant="outlined" onClick={handleClose2}>{t('Cancel')}</Button>
            <Button disableFocusRipple
            id={props?.data?.id + "select"}
                disableRipple
                tabIndex={0}
                  className={`formBuilder-MuiButton-outlined`} classes={{root:classes.btn2,label:classes.btnlabel}} size="small" variant="contained" onClick={handleSelect} color="primary">{t('Select')}</Button>    
        </DialogActions>
    </Dialog>

    {
              alertData.open === true &&
            <CustomizedAlert alertData={alertData} />
            }
    </div>
  );
}
